import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Quote = styled.blockquote`
    display: block;
    border-width: 2px 0;
    border-style: solid;
    border-color: #eee;
    padding: 1.5em 0 0.5em;
    margin: 1.5em 0;
    position: relative;
    font-size: 1.4em;
    width: 100%;
    max-width: 48rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5rem;
    &:before {
        content: "\\201C";
        position: absolute;
        top: 0em;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 3rem;
        height: 2rem;
        font: 5em/1.08em "PT Sans", sans-serif;
        color: #666;
        text-align: center;
    }
    ::after {
        content: "\\2013 \\2003"attr(cite);
        display: block;
        text-align: right;
        font-size: 0.875em;
        color: #e74c3c;
    }
    @media screen and (min-width: 60em) {
        width: 60%;
    }
    @media screen and (min-width: 30em) {
        max-width: 96rem;
        margin-left: 0;
        margin-right: 0;
        padding-right: 2rem;
    }
`

const Blockquote = ({ quote, cite }) => {
    return cite ? <Quote cite={cite}>{quote}</Quote> : <Quote>{quote}</Quote>
}

Blockquote.propTypes = {
    quote: PropTypes.string.isRequired,
    cite: PropTypes.string,
}

export default Blockquote
